import { CSSProperties } from 'react';
import { useTheme } from '../context/ThemeContext';

export function Skeleton({ style }: { style?: CSSProperties }) {
  const { colors } = useTheme();
  return (
    <div
      style={{
        backgroundColor: colors.skeletonBg,
        borderRadius: 8,
        animation: 'aga-pulse 1.6s ease-in-out infinite',
        ...style,
      }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div style={{ padding: 16, borderRadius: 16, marginBottom: 12 }}>
      <Skeleton style={{ height: 18, width: '40%', marginBottom: 10 }} />
      <Skeleton style={{ height: 14, width: '90%', marginBottom: 6 }} />
      <Skeleton style={{ height: 14, width: '80%' }} />
    </div>
  );
}

export function SkeletonList({ rows = 4 }: { rows?: number }) {
  return (
    <div>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', padding: '12px 0' }}>
          <Skeleton style={{ width: 44, height: 44, borderRadius: 14, marginRight: 12 }} />
          <div style={{ flex: 1 }}>
            <Skeleton style={{ height: 14, width: '56%', marginBottom: 8 }} />
            <Skeleton style={{ height: 12, width: '78%' }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export function SkeletonGrid({ items = 4 }: { items?: number }) {
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between' }}>
      {Array.from({ length: items }).map((_, i) => (
        <div key={i} style={{ width: '48%', marginBottom: 12 }}>
          <Skeleton style={{ aspectRatio: 1, borderRadius: 14 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonForm({ fields = 4 }: { fields?: number }) {
  return (
    <div>
      {Array.from({ length: fields }).map((_, i) => (
        <div key={i} style={{ marginBottom: 18 }}>
          <Skeleton style={{ height: 12, width: 110, marginBottom: 10 }} />
          <Skeleton style={{ height: 50, width: '100%', borderRadius: 12 }} />
        </div>
      ))}
    </div>
  );
}

export function SkeletonOrderRow() {
  return (
    <div style={{ padding: 12, borderRadius: 12, marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
        <Skeleton style={{ height: 12, width: 80 }} />
        <Skeleton style={{ height: 18, width: 60, borderRadius: 6 }} />
      </div>
      <Skeleton style={{ height: 14, width: '60%', marginBottom: 8 }} />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Skeleton style={{ height: 16, width: 60 }} />
        <Skeleton style={{ height: 12, width: 80 }} />
      </div>
    </div>
  );
}
